const GRAVITY = 32.17

export default function recoil (rifleWeightLb, bulletWeightGr, powderWeightGr, v0, f = 1.75) {
  const recoilVelocity = (bulletWeightGr * v0 + powderWeightGr * v0 * f) / (rifleWeightLb * 7000)
  const freeRecoilEnergy = (rifleWeightLb / (2 * GRAVITY)) * Math.pow(recoilVelocity, 2)
  return { freeRecoilEnergy, recoilVelocity }
}
